const url = "/login/";
const urlPreLogin = "/preloginuser/";
const mfaCode = "/mfa-otp/";
const smsCode = "/smsotp/";

export default {
  login: (signature, axios, credentials) => {
    return axios
      .post(url, credentials, {
        headers: { "X-SFC-Signature": signature(credentials) },
      })
      .then((response) => {
        if (response?.data?.error) {
          throw { response: { data: response.data } };
        } else {
          return { data: response.data };
        }
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },

  logout: (signature, axios, credentials) => {
    return axios
      .post("logout/", credentials, {
        headers: { "X-SFC-Signature": signature(credentials) },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error.response.data };
      });
  },
  prelogin: (signature, axios, credentials) => {
    return axios
      .post(urlPreLogin, credentials, {
        headers: { "X-SFC-Signature": signature(credentials) },
      })
      .then((response) => {
        if (response?.data?.error) {
          throw { response: { data: response.data } };
        } else {
          return { data: response.data };
        }
      })
      .catch((error) => {
        return { error: error?.response?.data || "Error" };
      });
  },
  generateMailCode: (signature, axios, form) => {
    let sign = signature(form);
    return axios
      .post(mfaCode, form, {
        headers: {
          "X-SFC-Signature": sign,
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data };
      });
  },
  verifyMailCode: (axios, param) => {
    return axios
      .get(`${mfaCode}?otp=${param.otp}&user_id=${param.user_id}`)
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data };
      });
  },
  generatePhoneCode: (signature, axios, form) => {
    let sign = signature(form);
    return axios
      .post(smsCode, form, {
        headers: {
          "X-SFC-Signature": sign,
        },
      })
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data };
      });
  },
  verifyPhoneCode: (axios, param) => {
    return axios
      .get(`${smsCode}?otp=${param.otp}&user_id=${param.user_id}`)
      .then((response) => {
        return { data: response.data };
      })
      .catch((error) => {
        return { error: error?.response?.data };
      });
  },
};
